import React from 'react';
import { Stack, Typography } from '@mui/material';

import { PKDFilledButton } from 'components/FilledButton';
import { Content } from './styles';
import { ReactComponent as EmptyIcon } from 'images/dashboard/empty-files.svg';

const EmptyCareList = ({ onAddCareCenter, ...rest }) => (
  <Content
    {...rest}>
    <EmptyIcon />
    <Stack
      spacing='8px' alignItems='center'>
      <Typography
        variant='pl3' color='primary.black1' sx={{ fontWeight: 700 }}>
        No data yet
      </Typography>
      <Typography
        variant='pl3' color='primary.black1'>
        Add your first Care Center
      </Typography>
      <PKDFilledButton
        onClick={onAddCareCenter} sx={{ width: '100%' }}>
        Add Care Center
      </PKDFilledButton>
    </Stack>
  </Content>
);

export default EmptyCareList;
